<template>
    <div class="form">
        <Form
            ref="info"
            :model="info"
            :rules="ruleValidate"
            :label-width="100"
            :viewonly="isView"
        >
            <Row>
                <Col span="12">
                    <FormItem prop="houseId" label="房源名称">
                        <form-lookup
                            v-model="lookupOptions.roomId"
                            :options.sync="lookupOptions.roomId"
                            placeholder="请选择"
                            title="选择房间"
                            textSymbol="title"
                            valueSymbol="id"
                            :modalHeight="600"
                            :modalWidth="900"
                        >
                            <select-room houseStatus = '1,2,3,4,5,6,7' showDetail/>
                        </form-lookup>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="repairTypeStr" label="维修类型">
                        <Select
                            v-model="info.repairTypeStr"
                            transfer
                            placeholder
                            multiple
                        >
                            <Option
                                v-for="item in repairTypeList"
                                :key="item.id"
                                :value="item.id"
                            >
                                {{ item.text }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem prop="cusName" label="联系人姓名">
                        <Input v-model="info.cusName" placeholder></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="cusMobile" label="联系人手机号">
                        <Input v-model="info.cusMobile" placeholder></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <FormItem prop="description" label="维修问题描述">
                        <Input
                            v-model="info.description"
                            type="textarea"
                            :rows="3"
                            placeholder="问题描述"
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="上传图片" prop="attachments">
                        <preview-upload
                            v-model="info.attachments"
                            multiple
                            :format="imgSuffix"
                            :maxNumber="10"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem prop="reserveDate" label="预约日期">
                        <DatePicker
                            v-model="info.reserveDate"
                            style="width: 100%"
                            type="date"
                            placeholder="预约日期"
                            placement="top"
                        >
                        </DatePicker>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem prop="reserveTime" label="预约时间">
                        <Select
                            v-model="info.reserveTime"
                            transfer
                            placeholder="请选择装修状态"
                            placement="top"
                        >
                            <Option
                                v-for="item in this.dict.reserveTime.toList()"
                                :value="item.id"
                                :key="item.id"
                                >{{ item.text }}
                            </Option>
                        </Select>
                    </FormItem>
                </Col>
            </Row>

            <Row>
                <Col span="12">
                    <FormItem
                        v-if="info.repairStatus === '4'"
                        prop="cancelRemark"
                        label="取消原因"
                    >
                        <Input
                            v-model="info.cancelRemark"
                            type="textarea"
                            :rows="3"
                            placeholder=""
                        ></Input>
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem
                        v-if="info.repairStatus === '4'"
                        prop="cancelTime"
                        label="取消时间"
                    >
                        <Input
                            v-model="info.cancelTimeStr"
                            type="textarea"
                            :rows="3"
                            placeholder=""
                        ></Input>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <FormItem prop="reportUser" label="报修人">
                        <Input v-model="info.reportUser" disabled></Input>
                    </FormItem>
                </Col>
            </Row>
        </Form>
    </div>
</template>
<script>
import config from '@/config'
import { deepCopy, ymd, ymdL } from '_u/helper'

import { billView, queryPeriods } from '@/api/bill'
import { addRepairForPc, repairView } from '@/api/repair'

import SelectRoom from '_vc/select-room'

export default {
    name: 'RepairForm',

    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        actionType: {
            type: [String, Number],
            default: '',
        },
    },

    components: { SelectRoom },

    inject: {
        $modal: {
            default: null,
        },
    },

    data() {
        return {
            info: {
                id: '', // 数据编号
                houseId: '',
                contractId: '',
                houseName: '',
                cusId: '',
                cusName: '',
                cusMobile: '',
                description: '',
                reserveDate: '',
                reserveTime: '',
                attachments: '',
                cancelRemark: '',
                cancelTime: '',
                repairStatus: '',
                repairType: '',
                repairTypeStr: '',
                ver: '',
                remark: '',
                reportUser: '', // 报修人
                // 报修人类型默认为房东
                reportUserType: '1',
            },
            isView: this.actionType === '2', // 查看
            imgSuffix: config.upload.imgSuffix,
            dict: {
                reserveTime: this.$dict.NULL,
                repairType: this.$dict.NULL,
            },
            lookupOptions: {
                roomId: [],
            },
            repairTypeList: [],
        }
    },

    computed: {
        ruleValidate() {
            return this.isView
                ? {}
                : {
                      houseId: [{ required: true, message: '必填' }],
                      //   contractId: [{ required: true, message: '必填' }],
                      //   houseName: [{ required: true, message: '必填' }],
                      //   cusId: [{ required: true, message: '必填' }],
                      //   cusName: [{ required: true, message: '必填' }],
                      //   cusMobile: [{ required: true, message: '必填' }],
                      description: [{ required: true, message: '必填' }],
                      reserveDate: [{ required: true, message: '必填' }],
                      reserveTime: [{ required: true, message: '必填' }],
                  }
        },
        status() {
            return this.info.billStatus[0]
        },
        user() {
            return this.$store.state.user.info
        },
    },
    methods: {
        fetch() {
            if (this.id) {
                return repairView(this.id)
            } else {
                return Promise.resolve()
            }
        },
    },

    mounted() {
        var $info = this.$refs.info

        // 按钮配置
        const btns = []
        if (this.isView) {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '关闭',
            })
        } else {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '取消',
            })
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        // 预加载
        this.$modal.beforeEnter((next) => {
            Promise.all([
                this.fetch(),
                this.$dict.get(['reserve_time', 'repair_type']),
            ])
                .then((args) => {
                    var [view, group] = args
                    if (group) {
                        Object.assign(this.dict, group)
                    }
                    this.repairTypeList = this.dict.repairType.toList()
                    if (view) {
                        var viewData = view.data.entity
                        // 实体数据
                        if (viewData.entity) viewData = viewData.entity
                        Object.keys(this.info).forEach(
                            (name) => (this.info[name] = viewData[name] || '')
                        )
                        this.info.cancelTimeStr = ymdL(this.info.cancelTime)
                        this.info.repairTypeStr = this.info.repairType?.split(
                            ','
                        )

                        this.lookupOptions.roomId.push({
                            id: viewData.houseId,
                            title: viewData.houseName,
                        })

                        //查看工单详情中要加上取消原因和取消时间、维修费用（若有就出现）
                    } else {
                        this.info.reportUser = this.user.nickName
                    }
                    this.$watch('lookupOptions.roomId', function (el) {
                        let house = el[0] || {}
                        Object.assign(this.info, {
                            houseId: house.houseId || '',
                            houseName: house.title || '',
                            contractId: house.contractId || '',
                            cusId: house.cusId || '',
                            cusName: house.cusName || '',
                            cusMobile: house.cusMobile || '',
                        })
                    })
                })
                .finally(() => {
                    next()
                })
        })

        // 确定
        this.$modal.onBtnClick('confirm', (next, options) => {
            $info
                .validate()
                .then(() => {
                    const info = deepCopy(this.info)
                    info.repairType = info.repairTypeStr.join(',')
                    info.reserveDate = ymd(info.reserveDate)
                    delete info.repairTypeStr
                    if (this.info.repairStatus !== '4') {
                        delete info.cancelRemark
                        delete info.cancelTime
                    }
                    return addRepairForPc(info)
                })
                .then((res) => {
                    if (this.id) {
                        this.$Message.success(this.$t('tips.update.success'))
                    } else {
                        this.$Message.success(this.$t('tips.add.success'))
                    }
                })
                .catch((err) => {
                    options.closeModal = false
                })
                .finally(() => {
                    next()
                })
        })
    },
}
</script>
<style lang="less" scoped></style>
